import { useAuth0 } from "@auth0/auth0-react";
import React, { useEffect, useState } from "react";
import App from "./App";
import "./App.css";
import LoginButton from "./LoginButton";
import { BrowserRouter } from "react-router-dom";
import logoVS from "./components/files/img/LOGO-VS-BIANCO.png";
import apiUrl from "./components/Apiurl";
import cdnBaseUrl from "./components/Cdn";

function Auth() {
  const profilo = useAuth0();
  const [autenticazione, setAutenticazione] = useState(null);

  const costruisciProfilo = (profilo, accessToken, datiDBuser) => {
    if (!datiDBuser || datiDBuser.err === "noUser") {
      console.log("no user");
      datiDBuser = null;
    }

    const permessiAPI = {};

    console.log("profilo", profilo);

    let username = datiDBuser?.username ?? profilo?.user?.email ?? "guest";
    let nickname = datiDBuser?.nickname ?? profilo?.user?.nickname ?? "ospite";
    let picture = datiDBuser?.pathIMMdef ?? null;
    let emoji = "🐄";
    let tema = datiDBuser?.tema ?? "rootTema";
    let title = datiDBuser?.titolo ?? "DOMINO";
    let home = datiDBuser?.home ?? "";
    let immBackup =
      datiDBuser?.pathIMMdef ??
      `${cdnBaseUrl}/images/vs-translations/netflixYellow100.png`;

    if (profilo.isAuthenticated && !profilo.isLoading && !!accessToken) {
      picture = profilo.user.picture;

      for (const permesso of accessToken?.permissions || []) {
        permessiAPI[permesso] = true;
      }
    }

    const utenteAutenticato = {
      ...datiDBuser,
      nickname: nickname,
      username: username,
      picture: picture,
      immBackup: immBackup,
      permessiAPI: permessiAPI,
      emoji: emoji,
      tema: tema,
      title: title,
      home: home,
    };

    console.log("utente autenticato", utenteAutenticato);
    return utenteAutenticato;
  };

  useEffect(() => {
    if (!profilo.isLoading && profilo.isAuthenticated) {
      console.log("fetching access token for new profile...");
      profilo.getAccessTokenSilently().then((token) => {
        const decoded = JSON.parse(atob(token.split(".")[1]));
        // console.log("retrieved access token", decoded);
        console.log("profilo email", profilo.user.email);
        fetch(apiUrl + "/auth/getUser/" + profilo.user.email)
          .then((resp) => resp.json())
          .then((datiDBuser) =>
            setAutenticazione(costruisciProfilo(profilo, decoded, datiDBuser)),
          );
      });
    } else {
      console.log("user not authenticated (or loading)");
      setAutenticazione(costruisciProfilo(profilo, null, null));
    }
  }, [profilo]);

  if (!autenticazione || profilo.isLoading) {
    return (
      <article class="vh-100 dt w-100 bg-navy">
        <div class="dtc v-mid tc white ph3 ph4-l">
          <h4 class="f6 f2-m f-subheadline-l fw6 tc">caricamento...</h4>
        </div>
      </article>
    );
  }

  if (!profilo.isAuthenticated) {
    return (
      <article class="vh-100 dt w-100 bg-navy">
        <div class="dtc v-mid tc white ph3 ph4-l">
          <img src={logoVS} width="50px" className="v-mid" alt="Logo"></img>
          <div className="login-button-container">
            <span>
              <LoginButton />
            </span>
          </div>
        </div>
      </article>
    );
  }

  return (
    <div className="rootTema">
      <BrowserRouter>
        <App autenticazione={autenticazione} />
      </BrowserRouter>
    </div>
  );
}

export default Auth;
